import { render, staticRenderFns } from "./ChatVideoMessage.vue?vue&type=template&id=5966172a&scoped=true&lang=pug&"
import script from "./ChatVideoMessage.vue?vue&type=script&lang=js&"
export * from "./ChatVideoMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChatVideoMessage.vue?vue&type=style&index=0&id=5966172a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5966172a",
  null
  
)

export default component.exports